<div class="bulk-action-create-container">
  <h3>Create New Bulk Action</h3>
  @if (bulkActionForm) {
    <form [formGroup]="bulkActionForm">
      <div class="mb-3">
        <label for="name" class="form-label">Bulk Action Name*</label>
        <input id="name" class="form-control" type="text" formControlName="name" required>
        <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="alert alert-danger">
          <div *ngIf="name?.errors?.['required']">Bulk action name is required.</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="imeis" class="form-label">IMEIs*</label>
        <span style="color: gray; font-size: 12px; padding-left: 5px;">comma or line-separated list</span>
        <textarea [cdkTextareaAutosize]="true" id="imeis" class="form-control imei-container"
                  formControlName="imeis" required></textarea>
        <div *ngIf="imeis?.invalid && (imeis?.dirty || imeis?.touched)" class="alert alert-danger">
          <div *ngIf="imeis?.errors?.['required']">IMEIs is required.</div>
          <div *ngIf="imeis?.errors?.['invalidImei']">Provide a comma or line-separated list of valid IMEIs.</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="type" class="form-label">Bulk Action Type*</label>
        <mat-select id="type" class="form-control" formControlName="type">
          <mat-option value="ASSIGN_DEDICATED_SMS">Hub - Assign Dedicated SMS</mat-option>
          <mat-option value="UNASSIGN_DEDICATED_SMS">Hub - Unassign Dedicated SMS</mat-option>
          <mat-option value="UPDATE_TRACKING_INTERVAL">Hub - Update Tracking Interval</mat-option>
          <mat-option value="MANAGE_GATEWAY_DEVICES">Gateway - Manage Devices</mat-option>
          <mat-option value="GATEWAY_DELETE_DEVICES">Gateway - Delete Devices</mat-option>
        </mat-select>
        <div *ngIf="type?.invalid && (type?.dirty || type?.touched)"
             class="alert alert-danger">
          <div *ngIf="type?.errors?.['required']">Bulk action type is required.</div>
        </div>
      </div>

      @if (this.type && this.type.value === 'ASSIGN_DEDICATED_SMS') {
        <div class="mb-3">
          <label for="countryCode" class="form-label">Country Code*</label>
          <mat-select id="countryCode" class="form-control" formControlName="countryCode">
            <mat-option value="US">US</mat-option>
            <mat-option value="CA">CA</mat-option>
          </mat-select>
          <div *ngIf="countryCode?.invalid && (countryCode?.dirty || countryCode?.touched)"
               class="alert alert-danger">
            <div *ngIf="countryCode?.errors?.['required']">Country code is required.</div>
          </div>
        </div>
      }

      @if (this.type && this.type.value === 'UPDATE_TRACKING_INTERVAL') {
        <div class="mb-3">
          <label for="movingIntervalSeconds" class="form-label">Moving Interval*</label>
          <mat-select id="movingIntervalSeconds" class="form-control" formControlName="movingIntervalSeconds">
            @for (option of intervalOptions; track option.seconds) {
              <mat-option [value]="option.seconds">{{option.label}}</mat-option>
            }
          </mat-select>
          <div *ngIf="movingIntervalSeconds?.invalid && (movingIntervalSeconds?.dirty || movingIntervalSeconds?.touched)"
               class="alert alert-danger">
            <div *ngIf="movingIntervalSeconds?.errors?.['required']">Moving interval is required.</div>
          </div>
        </div>

        <div class="mb-3">
          <label for="stationaryIntervalSeconds" class="form-label">Stationary Interval*</label>
          <mat-select id="stationaryIntervalSeconds" class="form-control" formControlName="stationaryIntervalSeconds">
            @for (option of intervalOptions; track option.seconds) {
              <mat-option [value]="option.seconds">{{option.label}}</mat-option>
            }
          </mat-select>
          <div *ngIf="stationaryIntervalSeconds?.invalid && (stationaryIntervalSeconds?.dirty || stationaryIntervalSeconds?.touched)"
               class="alert alert-danger">
            <div *ngIf="stationaryIntervalSeconds?.errors?.['required']">Stationary interval is required.</div>
          </div>
        </div>
      }

      @if (this.type && isGatewayBulkAction(this.type.value)) {
        <div class="mb-3">
          <label for="gatewayEnvironmentKey" class="form-label">Gateway Environment*</label>
          <mat-select id="gatewayEnvironmentKey" class="form-control" formControlName="gatewayEnvironmentKey">
            @for (gatewayEnvironment of gatewayEnvironments; track gatewayEnvironment.environmentKey) {
              <mat-option [value]="gatewayEnvironment.environmentKey">{{gatewayEnvironment.environmentKey}}</mat-option>
            }
          </mat-select>
          <div *ngIf="gatewayEnvironmentKey?.invalid && (gatewayEnvironmentKey?.dirty || gatewayEnvironmentKey?.touched)"
               class="alert alert-danger">
            <div *ngIf="gatewayEnvironmentKey?.errors?.['required']">Gateway environment is required.</div>
          </div>
          <div *ngIf="environmentLoadError" class="alert alert-danger">{{environmentLoadError}}</div>
        </div>
      }

      @if (this.type && this.type.value === 'MANAGE_GATEWAY_DEVICES') {
        <div class="mb-3">
          <label for="tenantId" class="form-label">Tenant</label>
          <input id="tenantId" class="form-control" type="text" formControlName="tenantId">
        </div>

        <div class="mb-3">
          <label for="connectorIds" class="form-label">Connectors</label>
          <span style="color: gray; font-size: 12px; padding-left: 5px;">comma or line-separated list</span>
          <textarea [cdkTextareaAutosize]="true" id="connectorIds" class="form-control imei-container"
                    formControlName="connectorIds"></textarea>
        </div>

        <div class="mb-3">
          <label for="groupId" class="form-label">Group</label>
          <input id="groupId" class="form-control" type="text" formControlName="groupId">
        </div>

        <div *ngIf="bulkActionForm.errors?.['gatewayTargetRequired'] && (bulkActionForm.dirty || bulkActionForm.touched)"
             class="alert alert-danger">
          Tenant, Connectors, or Group is required.
        </div>
        <div *ngIf="bulkActionForm.errors?.['invalidTenantId'] && (bulkActionForm.dirty || bulkActionForm.touched)"
             class="alert alert-danger">
          Tenant must be a valid UUID.
        </div>
        <div *ngIf="bulkActionForm.errors?.['invalidConnectorIds'] && (bulkActionForm.dirty || bulkActionForm.touched)"
             class="alert alert-danger">
          Connectors must be valid UUIDs.
        </div>
        <div *ngIf="bulkActionForm.errors?.['invalidGroupId'] && (bulkActionForm.dirty || bulkActionForm.touched)"
             class="alert alert-danger">
          Group must be a valid UUID.
        </div>
      }

      <div *ngIf="submitError" class="alert alert-danger">{{submitError}}</div>

      <button class="btn btn-light order-form-button" type="submit"
              (mousedown)="prevent($event)" (click)="cancel()">CANCEL</button>
      <button class="btn btn-primary order-form-button" type="submit"
              (click)="submit()" [disabled]="bulkActionForm.invalid">SUBMIT</button>
    </form>
  }
</div>
